import React, { PureComponent } from 'react';
import Locktube, { LOCKTUBE, LOCKTUBE_ACCESS_STATUS } from '../vodjs/Locktube';
import { noPtrEvts, noSelect, disableLongPressBS } from '../constants/Styles';
import { neuterEvt, noteInteraction} from '../vodjs/Utils';
import { env } from '../vodjs/settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

/*
Colorblind-compatible storage colors taken from 
https://www.tableau.com/about/blog/examining-data-viz-rules-dont-use-red-green-together

  blue    #026ca0 locked      overlay   2
  orange  #ff800f unlocked    overlay   1
  dkGray  #898989 requested   multiply  2
  ltGray  #cfcfcf filled      multiply  2

Coloring applied in Gimp using brush modes and number of passes as above.
*/

/**
 * This is the view instantiated when the storage hardware is detected to be storage_plus.
 */
export default class StoragePlusLoadingView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.getStorageImage = this.getStorageImage.bind(this);
    this.shouldShowInfo = false; //not showing help ((!this.props.showOpenClosed) && (env.drawerInfo.large || env.drawerInfo.medium || env.drawerInfo.small));
  }

  componentWillUpdate(nextProps, nextState) {
    // hack because props didn't seem to be updating for some reason
    this.props = nextProps;
  }

  drawerLabel(visLabel, pressLabel, attrs, passiveShowOpen, isRequested) {
    return (
      <>
        <div
          id={visLabel}
          style={{
            fontSize: attrs.fontSize,
            userSelect: 'none',
            cursor: 'pointer',
            color: this.getTextColor(pressLabel),
            textShadow: '0px 0px 20px black',
            fontWeight: 800,
            lineHeight: '0',
            textAlign: 'center',
            position: 'absolute',
            top: attrs.labelPosition.top,
            left: attrs.labelPosition.left,
            transform: `rotate(${attrs.rotationDegrees}deg)`,
          }}
          onClick={passiveShowOpen ? null : () => {noteInteraction(); this.props.toggleTubeSelected(pressLabel)}}
        >
          <p>{visLabel}</p>
        </div>
        <div
          style={{
            position: 'absolute',
            pointerEvents: 'none',
            top: attrs.labelPosition.top + attrs.checkmarkOffset.top,
            left: attrs.labelPosition.left + attrs.checkmarkOffset.left,
            transform: `rotate(${attrs.rotationDegrees}deg)`,
          }}
        >
          {isRequested && <FontAwesomeIcon color={this.getTextColor(pressLabel)} icon={faCheck} size="2x" />}
        </div>
        <p
          style={{
            fontSize: attrs.fontSize - 6,
            fontWeight: 300,
            position: 'absolute',
            pointerEvents: 'none',
            top: attrs.labelPosition.top + attrs.selectedTextOffset.top,
            left: attrs.labelPosition.left + attrs.selectedTextOffset.left,
            transform: `rotate(${attrs.rotationDegrees}deg)`,
            color: this.getTextColor(pressLabel),
          }}
        >
          {isRequested && 'Selected'}
        </p>
      </>
    );
  }

  render() {
    const passiveShowOpen = this.props.showOpenClosed; //patch1 true
    const tubes = this.props.locktubes.tubes;

    const attrs = {
      large: {
        heightWidth: { height: 180, width: 190, cursor: 'pointer' },
        topLeft: { top: 175, left: 0 },
        drawerLabel: {
          labelPosition: { top: 255, left: 20 },
          checkmarkOffset: { top: -10, left: 20 },
          selectedTextOffset: { top: 18, left: -6 },
          rotationDegrees: 9,
          fontSize: 23,
        },
      },
      medium: {
        heightWidth: { height: 96, width: 140, cursor: 'pointer' },
        topLeft: { top: 180, left: 450 },
        drawerLabel: {
          labelPosition: { top: 210, left: 495 },
          checkmarkOffset: { top: -13, left: 30 },
          selectedTextOffset: { top: 15, left: 15 },
          rotationDegrees: -13,
          fontSize: 23,
        },
      },
      small: {
        heightWidth: { height: 70, width: 140, cursor: 'pointer' },
        topLeft: { top: 130, left: 450 },
        drawerLabel: {
          labelPosition: { top: 145, left: 510 },
          checkmarkOffset: { top: -9, left: 13 },
          selectedTextOffset: { top: 11, left: -1 },
          rotationDegrees: -13,
          fontSize: 23,
        },
      },
    };

    let height = 392,
      width = 625;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pointerEvents: `${this.props.disabled ? 'none' : 'auto'}`,
        }}
      >
        <div style={{ height: height, width: width, position: 'relative' }}>
          <img
            draggable="false"
            src={require('../assets/images/splus_moxi_front_back-closed.png')}
            style={{ height: height, width: width, ...disableLongPressBS }}
          />

          {!passiveShowOpen && (
            <div
              style={{ position: 'absolute', ...attrs.large.topLeft }}
              onClick={() => {noteInteraction(); this.props.toggleTubeSelected('large');}}
              key={'large'}
            >
              <img
                draggable="false"
                style={{ ...attrs.large.heightWidth, ...disableLongPressBS }}
                src={this.getStorageImage('large')}
              />
            </div>
          )}

          {passiveShowOpen && tubes.large.unlocked && !tubes.large.disabled && (
            <img
              draggable="false"
              style={{
                position: 'absolute',
                ...attrs.large.topLeft,
                ...attrs.large.heightWidth,
                ...disableLongPressBS,
              }}
              src={require('../assets/images/splus/large/unlocked.png')}
            />
          )}

          {!passiveShowOpen && (
            <div
              style={{ position: 'absolute', ...attrs.medium.topLeft }}
              onClick={() => {noteInteraction(); this.props.toggleTubeSelected('medium');}}
              key={'medium'}
            >
              <img
                draggable="false"
                style={{ ...attrs.medium.heightWidth, ...disableLongPressBS }}
                src={this.getStorageImage('medium')}
              />
            </div>
          )}

          {passiveShowOpen && tubes.medium.unlocked && !tubes.medium.disabled && (
            <img
              draggable="false"
              style={{
                position: 'absolute',
                ...attrs.medium.topLeft,
                ...attrs.medium.heightWidth,
                ...disableLongPressBS,
              }}
              src={require('../assets/images/splus/medium/unlocked.png')}
            />
          )}

          {!passiveShowOpen && (
            <div
              style={{ position: 'absolute', ...attrs.small.topLeft }}
              onClick={() => {noteInteraction(); this.props.toggleTubeSelected('small');}}
              key={'small'}
            >
              <img
                draggable="false"
                style={{ ...attrs.small.heightWidth, ...disableLongPressBS }}
                src={this.getStorageImage('small')}
              />
            </div>
          )}

          {passiveShowOpen && tubes.small.unlocked && !tubes.small.disabled && (
            <img
              draggable="false"
              style={{
                position: 'absolute',
                ...attrs.small.topLeft,
                ...attrs.small.heightWidth,
                ...disableLongPressBS,
              }}
              src={require('../assets/images/splus/small/unlocked.png')}
            />
          )}

          {this.shouldShowInfo && (
            <div
              style={{ position: 'absolute', top: 0, right: 0, ...disableLongPressBS }}
              onClick={() => {noteInteraction(); this.setState({ info: !this.state.info });}}
              key={'question'}
            >
              <img
                draggable="false"
                style={{ height: 50, width: 50 }}
                src={require('../assets/images/questionMarkInCircle.png')}
              />
            </div>
          )}

          {(!passiveShowOpen || (tubes.large.unlocked && !tubes.large.disabled)) &&
            this.drawerLabel('Large', 'large', attrs.large.drawerLabel, passiveShowOpen, this.isRequested('large'))}
          {(!passiveShowOpen || (tubes.medium.unlocked && !tubes.medium.disabled)) &&
            this.drawerLabel('Medium', 'medium', attrs.medium.drawerLabel, passiveShowOpen, this.isRequested('medium'))}
          {(!passiveShowOpen || (tubes.small.unlocked && !tubes.small.disabled)) &&
            this.drawerLabel('Small', 'small', attrs.small.drawerLabel, passiveShowOpen, this.isRequested('small'))}

          {this.state.info && (
            <React.Fragment>
              {env.drawerInfo.large && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 220,
                    left: 0,
                    width: 220,
                    backgroundColor: '#2D9CA4',
                    opacity: 1.0,
                    borderRadius: 16,
                    borderWidth: 2,
                    borderColor: 'black',
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      userSelect: 'none',
                      color: 'white',
                      fontSize: 20,
                      fontWeight: 700,
                    }}
                  >
                    {env.drawerInfo.large}
                  </div>
                </div>
              )}

              {env.drawerInfo.small && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 265,
                    left: 340,
                    width: 220,
                    backgroundColor: '#2D9CA4',
                    opacity: 1.0,
                    borderRadius: 16,
                    borderWidth: 2,
                    borderColor: 'black',
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      userSelect: 'none',
                      color: 'white',
                      fontSize: 20,
                      fontWeight: 700,
                    }}
                  >
                    {env.drawerInfo.small}
                  </div>
                </div>
              )}

              {env.drawerInfo.medium && (
                <div
                  style={{
                    position: 'absolute',
                    top: 280,
                    left: 340,
                    width: 220,
                    backgroundColor: '#2D9CA4',
                    opacity: 1.0,
                    borderRadius: 16,
                    borderWidth: 2,
                    borderColor: 'black',
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      userSelect: 'none',
                      color: 'white',
                      fontSize: 20,
                      fontWeight: 700,
                      width: 160,
                    }}
                  >
                    {env.drawerInfo.medium}
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }

  isRequested(storageId) {
    const tubeInfo = this.props.locktubes.tubes[storageId];
    return tubeInfo.accessStatus === LOCKTUBE_ACCESS_STATUS.requested;
  }

  isUnlocked(storageId) {
    const tubeInfo = this.props.locktubes.tubes[storageId];
    return tubeInfo.unlocked;
  }

  isFilled(storageId) {
    const tubeInfo = this.props.locktubes.tubes[storageId];
    return tubeInfo.filled;
  }

  isDisabled(storageId) {
    const tubeInfo = this.props.locktubes.tubes[storageId];
    return tubeInfo.disabled;
  }

  getTextColor(storageId) {
    if (this.isDisabled(storageId)) return 'white'; // Prioritize disabled over unlocked
    else if (this.isUnlocked(storageId)) return 'black'; // Easier to read against orange background
    else return 'white';
  }

  /**
   * Retrieves the image of the storage container associated with the given storageId, taking
   * into account the corresponding storage's status (acess status, locked status, filled
   * status).
   *
   * @param {string} storageId - the id of the storage container.
   * @return a value suitable for assignment as the source of an img.
   */
  getStorageImage(storageId) {
    //these case statements can't be compacted, due to "require"
    // in react having to be passed literal strings.
    if (storageId == 'large') {
      if (this.isDisabled(storageId)) return require('../assets/images/splus/large/filled.png');
      else if (this.isRequested(storageId)) return require('../assets/images/splus/large/requested.png');
      else if (this.isUnlocked(storageId)) return require('../assets/images/splus/large/unlocked.png');
      else if (this.isFilled(storageId)) return require('../assets/images/splus/large/filled.png');
      else return require('../assets/images/splus/large/locked.png');
    }
    else if (storageId == 'medium') {
      if (this.isDisabled(storageId)) return require('../assets/images/splus/medium/filled.png');
      else if (this.isRequested(storageId)) return require('../assets/images/splus/medium/requested.png');
      else if (this.isUnlocked(storageId)) return require('../assets/images/splus/medium/unlocked.png');
      else if (this.isFilled(storageId) || this.isDisabled(storageId))
        return require('../assets/images/splus/medium/filled.png');
      else return require('../assets/images/splus/medium/locked.png');
    }
    else if (storageId == 'small') {
      if (this.isDisabled(storageId)) return require('../assets/images/splus/small/filled.png');
      else if (this.isRequested(storageId)) return require('../assets/images/splus/small/requested.png');
      else if (this.isUnlocked(storageId)) return require('../assets/images/splus/small/unlocked.png');
      else if (this.isFilled(storageId) || this.isDisabled(storageId))
        return require('../assets/images/splus/small/filled.png');
      else return require('../assets/images/splus/small/locked.png');
    }
    else {
      throw new Error('Uncased storageId: ' + storageId);
    }
  }
}
